/* src/app/components/download/download.component.scss */
.lexbe-card {
  padding: 0;
  width: 100%;
  border-radius: 3px;
}
.lexbe-card mat-card-header {
  background: #243E90;
  color: white;
  font-size: 22px;
  margin: 0;
  padding: 14px 0 14px 32px;
  border-radius: 3px 3px 0 0;
  font-weight: 400;
}
.lexbe-card mat-card-content {
  padding: 16px;
  font-size: 14px;
}
.lexbe-button.blue {
  display: flex;
  margin: 0 auto;
  align-items: center;
  background: #243E90;
  color: white;
  cursor: pointer;
  padding: 7px 44px;
  font-size: 14px;
  line-height: 36px;
  min-width: 64px;
  font-weight: 500;
  height: unset;
  font-weight: 500;
}
.delete-message {
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
}
/*# sourceMappingURL=download.component.css.map */
